import { IActionEvent } from 'app/api/event/model'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseEmpty } from 'app/components/common/BaseEmpty'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { Loading } from 'app/components/common/Loading'
import { SectionBase } from 'app/components/common/SectionBase'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import _ from 'lodash'
import { BORDER_RADIUS, formatMoney } from 'parkway-web-common'
import { useMemo } from 'react'
import styled from 'styled-components'

interface IData extends IActionEvent {
  key: string
  color?: string
  total?: number
}

export const Top10EventHaveMemberLayout = ({
  top10MemberPrize,
  isLoading,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  top10MemberPrize: any[]
  isLoading?: boolean
}) => {
  const dataTop10EventHaveMember: IData[] = useMemo(() => {
    const top1Value = _.maxBy(top10MemberPrize, 'total')?.total
    const top2Value = _.maxBy(
      top10MemberPrize.filter(item => item.total !== top1Value),
      'total',
    )?.total

    const top3Value = _.maxBy(
      top10MemberPrize.filter(
        item => item.total !== top1Value && item.total !== top2Value,
      ),
      'total',
    )?.total

    return top10MemberPrize?.map((item, index) => {
      let key = `${index + 1}`

      if (index > 0 && item?.total === top10MemberPrize[index - 1]?.total) {
        key = '-'
      }

      let color: undefined | string = undefined

      if (item?.total === top1Value) {
        color = convertedVariables.statesGreenColor
      } else if (item?.total === top2Value) {
        color = convertedVariables.otherBlueColor
      } else if (item?.total === top3Value) {
        color = convertedVariables.statesRedColor
      }

      return {
        ...item,
        key,
        color,
      }
    })
  }, [top10MemberPrize])

  return (
    <SectionBase title="Danh sách hoạt động có nhiều đoàn viên tham gia nhất">
      <BaseSpace size={8}>
        <HeaderWrapper align={'middle'} justify={'space-between'}>
          <BaseCol xl={2}>
            <BaseText children={'STT'} fontWeight="semibold" opacity="0.7" />
          </BaseCol>
          <BaseCol xl={14}>
            <BaseText
              children={'Tên hoạt động'}
              fontWeight="semibold"
              opacity="0.7"
            />
          </BaseCol>
          <BaseCol xl={3}>
            <BaseText
              children={'Số người'}
              fontWeight="semibold"
              opacity="0.7"
            />
          </BaseCol>
          <BaseCol xl={5}>
            <BaseText
              children={'Sự kiện'}
              fontWeight="semibold"
              opacity="0.7"
            />
          </BaseCol>
        </HeaderWrapper>
        <ContentWrapper size={4}>
          {dataTop10EventHaveMember?.length ? (
            dataTop10EventHaveMember?.map((item, index) => {
              return (
                <ItemWrapper
                  key={index}
                  align={'middle'}
                  justify={'space-between'}
                >
                  <BaseCol xl={2}>
                    <BaseText
                      children={item?.key}
                      fontWeight="semibold"
                      style={{
                        color: item?.color,
                      }}
                    />
                  </BaseCol>
                  <BaseCol xl={14}>
                    <BaseSpace size={4}>
                      <BaseText
                        children={item?.name}
                        fontWeight="semibold"
                        fontSize="xs"
                        style={{
                          color: item?.color,
                        }}
                      />
                    </BaseSpace>
                  </BaseCol>
                  <BaseCol xl={3}>
                    <BaseText
                      children={`${formatMoney(item?.total ?? 0, '')}`}
                      fontWeight="semibold"
                      style={{
                        color: item?.color,
                      }}
                    />
                  </BaseCol>
                  <BaseCol xl={5}>
                    <BaseText
                      children={item?.event?.name_event ?? '-'}
                      fontWeight="semibold"
                      style={{
                        color: item?.color,
                      }}
                    />
                  </BaseCol>
                </ItemWrapper>
              )
            })
          ) : (
            <BaseEmpty />
          )}
        </ContentWrapper>
      </BaseSpace>
      {isLoading ? <Loading isAbsolute size="small" /> : null}
    </SectionBase>
  )
}

const HeaderWrapper = styled(BaseRow)`
  width: 100%;
  padding: ${BORDER_RADIUS};
  background-color: ${convertedVariables.backgroundColor};
`

const ItemWrapper = styled(BaseRow)`
  width: 100%;
  padding: ${BORDER_RADIUS};
  background-color: ${convertedVariables.backgroundColor};

  border-radius: ${BORDER_RADIUS};
  box-shadow: 0px 0.5px 2px rgba(0, 0, 0, 0.1);
`

const ContentWrapper = styled(BaseSpace)`
  height: 200px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`
